import { createInstance } from 'i18next';
import { i18Locales } from '@Hotels-at-Home/hah-fe-core/locales';
import { i18LocalLocales } from '../../public/locales';
import { merge } from 'lodash';

// TODO: Get rid of this flow. Use MainApp translation within a CorePackage
const translation = {
  en: merge({}, i18Locales.en, i18LocalLocales.en),
  de: merge({}, i18Locales.de, i18LocalLocales.de),
  fr: merge({}, i18Locales.fr, i18LocalLocales.fr),
  es: merge({}, i18Locales.es, i18LocalLocales.es),
};

export const getI18nInstance = (lng: string) =>
  createInstance(
    {
      fallbackLng: 'en',
      debug: false,
      // debug: true only for testing,
      lng,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
        useSuspense: false,
      },
      resources: {
        en: {
          translation: translation.en,
        },
        de: {
          translation: translation.de,
        },
        fr: {
          translation: translation.fr,
        },
        es: {
          translation: translation.es,
        },
      },
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _err => {},
  );
export default {};
